enum Event {
  NAVIGATE = 'NAVIGATE',
  ROW_CLICK = 'ROW_CLICK',
  ROW_SELECT = 'ROW_SELECT',
  SELECT = 'SELECT',
  SELECT_ALL = 'SELECT_ALL',
  CLEAR_SELECTION = 'CLEAR_SELECTION',
  SORT = 'SORT',
  PAGE = 'PAGE',
  FILTER = 'FILTER',
  CLEAR_FILTER = 'CLEAR_FILTER',
  CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS',
  INLINE_ACTION = 'INLINE_ACTION',
  BATCH_ACTION = 'BATCH_ACTION',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
  NEW_RECORD_DIALOG = 'NEW_RECORD_DIALOG',
  EDIT_RECORD_DIALOG = 'EDIT_RECORD_DIALOG',
  DELETE_RECORD_DIALOG = 'DELETE_RECORD_DIALOG',
  SEARCH_RESULT_CLICK = 'SEARCH_RESULT_CLICK',
  TAB_CLICK = 'TAB_CLICK',
  ROW_EXPAND = 'ROW_EXPAND',
  TOKEN_REGENERATE = 'TOKEN_REGENERATE',
  WORLD_MAP_OBJECT_CLICK = 'WORLD_MAP_OBJECT_CLICK',
  CALENDAR_DAY_CLICK = 'CALENDAR_DAY_CLICK',
  RECORD_REMOVE = 'RECORD_REMOVE',
  RECORD_ADD = 'RECORD_ADD',
  UNDO_CLICK = 'UNDO_CLICK',
  PRINT = 'PRINT',
  HISTORY = 'HISTORY',
  CHART_CLICK = 'CHART_CLICK',
  QR_CODE_SETTINGS_CLICK = 'QR_CODE_SETTINGS_CLICK',
  DOWNLOAD_QR_CODE = 'DOWNLOAD_QR_CODE',
}

export default Event
